const companyUserSelector = state => state?.authCompany?.company_user;
export default companyUserSelector;
